import { currentFormat } from "./cases";



export const handleCurrent = (value: any, withFormat : boolean = false) => {
    const newValue = typeof value === 'number' ? value : Number(value?.replace(/\$|,|[a-z|A-Z]/g, '')) ;
    return withFormat ? `${currentFormat(Number.isNaN(newValue) ? 0 : newValue)}` : newValue;
  };

  export const validateLogo = /^https?:\/\/.+(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;